<template>
  <div>
    <div class="loader row justify-center" v-if="actsLoading">
      <q-spinner-mat size="100px" style="color:#C1DDF5FF"/>
    </div>

    <div v-else>
      <div v-if="!ownerId">
        Для работы с актами необходимо указать
        <router-link :to="`/projects/${ this.$route.params.id }#client`">клиента</router-link>
      </div>

      <div v-else-if="actsError || !isPaymentsDataFilled">
        Для работы с актами необходимо
        <router-link :to="`/projects/${ this.$route.params.id }/requisites`">заполнить реквизиты проекта</router-link>
      </div>

      <div v-else>
        <acts-list-table
            :acts="acts"
            :acts-loading="actsLoading"
            @openModal="modal"
        />

        <acts-list-modal
            v-if="modalOpened"
            :opened="modalOpened"
            :bill-number="billNumber"
            :document-id="documentId"
            @modal-closed="modalOpened = false"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import ActsListModal from './ActsListModal'
import ActsListTable from './ActsListTable'
import { QSpinnerMat } from 'quasar'

export default {
  name: 'ActsList',

  components: {
    ActsListTable,
    ActsListModal,
    QSpinnerMat,
  },

  data () {
    return {
      perPageOptions: [10, 20, 40, 60],
      pagination: {
        page: 1,
        rowsPerPage: 20,
      },
      modalOpened: false,
      billNumber: null,
      documentId: null,
    }
  },

  computed: {
    ...mapState({
      acts: state => state.project.acts.map((act) => ({ ...act, deleting: false, regenerating: false })),
      actsLoading: state => state.project.actsLoading,
      actsError: state => state.project.actsError,
      paymentsData: state => state.project.requisites,
    }),

    ...mapGetters({
      ownerId: 'project/ownerId',
      requisites: 'project/requisites',
    }),

    isPaymentsDataFilled () {
      return this.paymentsData.edrpou && this.paymentsData.company_type >= 0
    },
  },

  watch: {
    ownerId () {
    },
  },

  mounted () {
    this.$store.dispatch('project/fetchActs', this.$route.params.id)
  },

  methods: {
    modal (row) {
      if (row.count_documents <= 0) {
        return false
      }

      this.modalOpened = true
      this.billNumber = row.bill_number
      this.documentId = row.id
    },
  },
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/ActsList/ActsList.vue